  <app-header *ngIf="showLayout"></app-header>

<router-outlet></router-outlet>

<app-footer *ngIf="showLayout"></app-footer>
